import styled from "styled-components"

// Text sizes are in rem, to allow for larger base font on mobile devices
// without endless media queries. Conversion chart below for reference
// Default base font size is 14px. Mobile device base font size is 16px.

// Desktop    Rem value     Mobile
//---------------------------------
// 12 px      0.86rem       ~14px
// 13 px      0.92rem       ~15px
// 14 px      1rem          16px
// 16 px      1.14rem       ~18px
// 18 px      1.25rem       ~20px
// 20 px      1.43rem       ~22px
// 22 px      1.57rem       ~24px

/*
 * SHARED TEXT STYLES
 */

export const Heading = styled.h1`
  font-family: ${(props) => props.theme.font.primary};
  font-size: 1.14rem;
  color: ${(props) => props.theme.text.default};
`

export const P = styled.p`
  font-family: ${(props) => props.theme.font.primary};
  font-size: ${(props) => props.theme.text.para};
  color: ${(props) => props.theme.text.default};
  margin: 2px 0;
  line-height: normal;
`

export const Link = styled.a`
  font-family: ${(props) => props.theme.font.primary};
  font-size: ${(props) => props.theme.text.para};
  color: ${(props) => props.theme.text.link};
  margin: 2px 0;
  line-height: normal;

  &:visited {
    color: ${(props) => props.theme.colors.link};
    font-size: inherit;
  }
`
